@for (flow of flows; track flow.stepSequence; let i = $index) {
    <app-flow-step-panel
        [flow]="flow"
        [index]="i"
        [totalSteps]="flows.length"
        [flows]="flows"
        [availableStatuses]="availableStatuses"
        [availableRoles]="availableRoles"
        [documentTypes]="documentTypes"
        (changed)="changed.emit()"
        (moveUp)="moveUp.emit(i)"
        (moveDown)="moveDown.emit(i)"
        (remove)="remove.emit(i)" />
}

@if (flows.length === 0) {
    <div class="panel">
        <div class="panel-body text-center text-muted">
            <i class="fas fa-info-circle me-1"></i> Este proceso no tiene ningún flujo configurado.
            <br> Agregue pasos para definir cómo debe transitar.
        </div>
    </div>
}
